import axios from 'axios';
import { baseUrl } from '@/config';

export default {
  /**
   * [이벤트>이벤트현황] 이벤트현황 정보 조회
   * @author najongdang
   * @param  {Object} params treeType 및 필터링 정보
   * @return {Map}        해당 위젯에 표현될 성능정보
   */
  getEventStatusList(params) {
    return axios.post(`${baseUrl}/event/event-status/get-event-status-list.do`, params);
  },
  releaseEvent(params) {
    return axios.post(`${baseUrl}/event/event-status/release-event.do`, params);
  },
  /**
   * 이벤트 현황 엑셀파일명을 조회한다.
   * @param  {[type]} params [description]
   * @return {[type]}        [description]
   * @author jda
   */
  getEventStatusExcelName(params) {
    return axios.post(`${baseUrl}/event/event-status/get-event-status-excel-name.do`, params);
  },
};



// WEBPACK FOOTER //
// ./src/api/event/event-status.js